import { createActivityModalExecutor } from '@organisms/actions/createActivityModalExecutor';
import { getActivityIdFromCompositeId } from '@utils/helpers';
import { ITakeToWorkProps } from './ITakeToWorkProps';
import { TakeToWorkModal } from './TakeToWorkModal';

export const TakeToWorkExecutor = createActivityModalExecutor<ITakeToWorkProps>({
    modal: TakeToWorkModal,
    defaultModalSize: 'm',
    mapProps: ({ objId, action, okButtonText, cancelButtonText, modalSize, completeHandler }) => ({
        objId: getActivityIdFromCompositeId(objId),
        actionKey: action.key,
        okButtonText,
        cancelButtonText,
        modalSize,
        hideComment: action.options?.hideComment ?? false,
        completeHandler,
    }),
});
